const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  generateUrlJwt ({ state, commit, rootState }, params) {
    return rootState.axios.get('/ada/v1frontend/login/generate-url-jwt', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
